import { useMutation } from '@tanstack/react-query'
import { useApiClientInvestment } from '~/@api/client/useApiClientInvestment'

function useWithdrawInvestmentReservation() {
  const client = useApiClientInvestment()

  return useMutation({
    mutationFn: async ({ investmentId }: { investmentId: string }) => {
      return await client.investment
        .orderControllerWithdrawOrder(investmentId, {
          secure: true,
        })
        .then((res) => res.data)
    },
  })
}

export { useWithdrawInvestmentReservation }
